<template>
  <span class="timePicker">
    <h4>{{ label }}</h4>
    <h2>{{ localHours + ':' + pad(localMinutes) }}</h2>
    <slider
      label="HR "
      :value="localHours"
      :max="23"
      @slider-change="hoursChanged"
    />
    <slider
      label="MIN"
      :value="localMinutes"
      :max="59"
      @slider-change="minutesChanged"
    />
  </span>
</template>

<script>
  import slider from '../../slider/src/slider.vue';
  let timePicker = {
    name: 'TimePicker',
    components: {
      slider: slider,
    },
    props: {
      label: {
        type: String,
        default: ''
      },
      hours: {
        type: Number,
        default: 0
      },
      minutes: {
        type: Number,
        default: 0,
      },
    },
    watch: {
      hours: function(value) {
        this.localHours = value;
      },
      minutes: function(value) {
        this.localMinutes = value;
      },
    },
    computed: {
      styles: function() {
        return {
          color: this.color
        };
      },
    },
    data: function() {
      return {
        localHours: this.hours,
        localMinutes: this.minutes
      };
    },
    methods: {
      hoursChanged: function(sliderValue) {
        this.localHours = sliderValue;
        this.$emit('time-change', {
          hours: this.localHours,
          minutes: this.localMinutes
        });
      },
      minutesChanged: function(sliderValue) {
        this.localMinutes = sliderValue;
        this.$emit('time-change', {
          hours: this.localHours,
          minutes: this.localMinutes
        });
      },
      pad: function(number) {
        if (number > 9) {
          return number;
        }
        return '0' + number;
      },
    }
  };
  export default timePicker;
</script>

<style lang="scss" scope>
.timePicker {
  h2, h4 {
    text-align: center;
    font-family: var(--font-family);
    font-weight: bold;
  }
  h4 {
    margin-bottom: 0;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: unset;
  }
  h2 {
    color: var(--default-color);
    margin-top: 5px;
    font-size: 20px;
    letter-spacing: unset;
  }
}
</style>
